<style>
#header{
  height: 50px;
  background-color: #1376EB;
  width: 100%;
}
#header a.logo{
  display: inline-block;
  width: 190px;
  height: 50px;
  background: url('../../assets/common/logo.svg') no-repeat center;
  background-size: 80%;
  text-indent: -9999px;
}
#header .islogin-container , #header .nologin-container{
  float: right;
  color:white;
  font-size: 14px;
  line-height: 50px;
  margin-right: 15px;
}
#header .islogin-container .exit {
  cursor: pointer;
  margin-left: 5px;
}
.nologin-container .login{
  margin-right: 15px;
  cursor: pointer;
}
.nologin-container a.reg {
  text-decoration: none;
  color: white;
}
</style>

<template>
  <div id="header">
    <div class="container">
      <a class="logo" href="/" title="优化指数">易展优化指数</a>
      <div class="islogin-container" v-show="user.uname">
        <span>您好,</span>
        <span>{{user.uname}}</span>
        <span class="exit" @click="logout"> [ 退出 ]</span>
      </div>
      <div class="nologin-container" v-show="!user.uname">
        <span class="login" @click="login">登录</span>
        <a href="http://www.yi-z.cn/Default_oldPage.aspx#reg" target="_blank" class="reg">注册</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'header',
  computed: mapState({ user: state => {
    return state.user
  }}),
  mounted () {
    window.addEventListener('message', this.logouted)
  },
  methods: {
    logouted (e) {
      if (e.data === 'logined') {
        window.location.href = '/'
        /* this.$router.push({
          name: 'index'
        }) */
      }
    },
    logout () {
      let iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = `${process.env.ADMIN_URI}/account/logoff`
      document.body.appendChild(iframe)
    },
    login () {
      window.location.href = `${process.env.ADMIN_URI}account/login?returnUrl=${window.location.href}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// header.vue?26be4c5b